import React from 'react';
import styled from 'styled-components';
import { breakpoint, theme } from '../../../theme';

export type HeadingSize = 1 | 2 | 3 | 4 | 5 | 6;

const headingSizes = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6',
} as const;

type Headings = {
  [H in HeadingSize]: (typeof headingSizes)[H];
}[HeadingSize];

type BaseHeadingProps = React.HTMLAttributes<HTMLHeadingElement>;

export type StyledHeadingProps = BaseHeadingProps & {
  size: HeadingSize;
  as: Headings;
};

const BaseHeading = styled.h1<StyledHeadingProps>`
  color: ${({ color }) => (color ? color : theme.colors.primary.graysGray)};
  padding: 0;
  margin: 0;

  ${({ size }) => theme.typography.headings[size]['sm-lg']};

  ${breakpoint('xl')<StyledHeadingProps>`
    ${({ size }) => theme.typography.headings[size]['xl']};
  `};
`;

export type HeadingProps = BaseHeadingProps & {
  size?: HeadingSize;
  component?: Headings;
  children: string | React.ReactNode;
};

export const Heading: React.FC<HeadingProps> = ({
  children,
  size = 1,
  component: Component = headingSizes[size],
  ...props
}) => {
  return (
    <BaseHeading size={size} as={Component} {...props}>
      {children}
    </BaseHeading>
  );
};
